import { useBlocker } from "@tanstack/react-router";

import { Button, Inline, Modal, Stack, Text } from "../../ui";

export function AlertRuleAuthoringLeaveGuard({
  isDirty,
}: {
  isDirty: boolean;
}) {
  const blocker = useBlocker({
    disabled: !isDirty,
    enableBeforeUnload: () => isDirty,
    shouldBlockFn: () => true,
    withResolver: true,
  });
  const isBlocked = blocker.status === "blocked";
  const keepEditing = () => {
    blocker.reset?.();
  };

  return (
    <Modal
      ariaLabel="Discard unsaved alert rule changes?"
      isOpen={isBlocked}
      onDismiss={keepEditing}
    >
      <Stack gap={4}>
        <Text>
          This alert rule has unsaved changes. Leaving this page discards them.
        </Text>
        <Inline gap={2}>
          <Button onClick={keepEditing} type="button">
            Keep editing
          </Button>
          <Button
            onClick={() => {
              blocker.proceed?.();
            }}
            type="button"
            variant="danger"
          >
            Discard changes
          </Button>
        </Inline>
      </Stack>
    </Modal>
  );
}
